module.exports = __webpack_public_path__ + "img/setup3.ec44b7c1.png";